import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { SketchPicker } from 'react-color'
import cx from 'classnames'

import { useFormControl } from '../FormControl'
import Input from '../Input'
import styles from './ColorPicker.module.scss'

const ColorPicker = (props) => {
  const { isInvalid } = useFormControl()

  const [showPicker, setShowPicker] = useState(false)
  const [internalSelectedColor, setInternalSelectedColor] = useState('#D0021B')
  const popupRef = useRef(null)

  const selectedColor = props.value ?? internalSelectedColor

  const handleClick = () => {
    setShowPicker(!showPicker)
  }

  const handleClose = () => {
    setShowPicker(false)
  }

  const setColor = (input) => {
    const hexColor = input.startsWith('#') ? input : '#' + input

    if (props.value && props.onChange) {
      props.onChange(hexColor)
      return
    }

    setInternalSelectedColor(hexColor)
  }

  const handleColorChange = (color) => {
    setColor(color.hex)
  }

  const handleInputChange = (e) => {
    setColor(e.target.value)
  }

  const selectedColorWithoutHash = useMemo(() => {
    return selectedColor.startsWith('#') ? selectedColor.substring(1) : selectedColor
  }, [selectedColor])

  useEffect(() => {
    if (!popupRef.current) {
      return
    }

    const handleOutsideClick = (e) => {
      const clickedOutside = !popupRef.current.contains(e.target)

      if (clickedOutside && showPicker) {
        handleClose()
      }
    }

    document.addEventListener('mousedown', handleOutsideClick)

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [showPicker])

  return (
    <Fragment>
      <div className={cx(styles.Group, { [styles.Invalid]: isInvalid })}>
        <div className={styles.Unit}>#</div>
        <Input
          className={styles.Control}
          placeholder={props.placeholder}
          value={selectedColorWithoutHash}
          onChange={handleInputChange}
        />
        <div className={styles.PickerContainer} onClick={handleClick} ref={popupRef}>
          <button type='button' className={styles.Preview} style={{ backgroundColor: selectedColor }} />
          <div className={styles.Picker}>
            {showPicker && (
              <div className={styles.Popover}>
                <SketchPicker disableAlpha color={selectedColor} onChange={handleColorChange} />
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  )
}

ColorPicker.propTypes = {
  /**
   * Value, a hex color
   */
  value: PropTypes.string,
  /**
   * Placeholder for the input
   */
  placeholder: PropTypes.string,
  /**
   * Optional change handler
   */
  onChange: PropTypes.func
}

ColorPicker.defaultProps = {
  value: null,
  onChange: undefined
}

export default ColorPicker
